import PropTypes from 'prop-types';
import React from 'react';
import { useDraggable, useDroppable } from '@dnd-kit/core';

const GridItemCard = ({
  foldered,
  currentUser,
  selectedFolderedItems,
  togglefolderedItemSelected,
  fetchCalendarEventAttachment,
  team,
  onNavigateToFolder,
  onContextMenu
}) => {
  const canDrag = currentUser.can_manage_calendar_event_attachments && foldered.item.user_can_change;
  const isFolder = foldered.item.is_folder;
  const isEmpty = isFolder && foldered.item.foldered_items_count === 0;
  const isSelected = selectedFolderedItems.some((fi) => fi.id === foldered.id);

  const { attributes, listeners, setNodeRef: setDragRef, isDragging } = useDraggable({
    id: 'grid-foldered-' + foldered.id,
    data: { foldered: foldered },
    disabled: !canDrag
  });

  const { setNodeRef: setDropRef, isOver } = useDroppable({
    id: 'grid-drop-folder-' + foldered.id,
    data: { foldered: foldered },
    disabled: !isFolder || !foldered.item.can_be_move_target
  });

  const setNodeRef = (node) => {
    setDragRef(node);
    if (isFolder) {
      setDropRef(node);
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    if (isEmpty) return;
    if (isFolder) {
      onNavigateToFolder(foldered.item.id);
    } else {
      fetchCalendarEventAttachment(team, foldered.item.id);
    }
  };

  const handleContextMenu = (e) => {
    if (onContextMenu) {
      onContextMenu(e, foldered);
    }
  };

  const cardClassName = [
    "asset-grid-card",
    isSelected ? "selected" : "",
    isOver && isFolder ? "drag-over" : "",
    isDragging ? "dragging" : "",
    isEmpty ? "empty-folder" : ""
  ].filter(Boolean).join(" ");

  return (
    <div
      ref={setNodeRef}
      className={cardClassName}
      onClick={handleClick}
      onContextMenu={handleContextMenu}
      {...attributes}
      {...listeners}
    >
      {currentUser.can_manage_calendar_event_attachments && foldered.item.user_can_change ? (
        <div className="grid-card-checkbox"
             onClick={(e) => e.stopPropagation()}>
          <div className="custom-control custom-checkbox custom-checkbox-table">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => togglefolderedItemSelected(foldered)}
              id={"grid-card-" + foldered.id}
              className="custom-control-input"
            />
            <label htmlFor={"grid-card-" + foldered.id} className="custom-control-label">&nbsp;</label>
          </div>
        </div>
      ) : null}

      <div className="grid-card-thumbnail">
        {isFolder ? (
          <i className="fas fa-folder grid-card-folder-icon"></i>
        ) : foldered.item.is_image && foldered.item.compressed_file_url ? (
          <img src={foldered.item.compressed_file_url} alt={foldered.item.human_file_name} />
        ) : (
          <i className={"fas " + foldered.item.fontawesome_icon_class + " grid-card-icon"}></i>
        )}
      </div>

      {isFolder && foldered.item.foldered_items_count !== undefined ? (
        <span className="grid-card-count-badge">
          {foldered.item.foldered_items_count}
        </span>
      ) : null}

      <div className="grid-card-name" title={foldered.item.human_file_name}>
        {foldered.item.human_file_name}
      </div>
      <div className="grid-card-meta">
        {foldered.item.human_updated_at}
        {foldered.item.human_file_size && foldered.item.human_file_size !== "--"
          ? " \u00b7 " + foldered.item.human_file_size
          : ""}
      </div>
      {foldered.item.is_image && foldered.item.human_dimensions ? (
        <div className="grid-card-meta">
          {foldered.item.human_dimensions}
        </div>
      ) : null}

      {foldered.permission_set_id ? (
        <div className="grid-card-meta">
          <i className="far fa-lock small text-danger"></i>
        </div>
      ) : null}
    </div>
  );
};

GridItemCard.propTypes = {
  foldered: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  selectedFolderedItems: PropTypes.array.isRequired,
  togglefolderedItemSelected: PropTypes.func.isRequired,
  fetchCalendarEventAttachment: PropTypes.func.isRequired,
  team: PropTypes.object.isRequired,
  onNavigateToFolder: PropTypes.func.isRequired,
  onContextMenu: PropTypes.func
};

export default GridItemCard;
